module.exports = __webpack_public_path__ + "img/logo-um-fs-ang.2143c5f3.png";